import React, { Component } from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';

const team = {
    crewList: [
        {
            crewItemImg: '',
            crewItemTitle: 'Ильдар Васин',
            crewItemSubtitle: 'Менеджер проекта',
        },
        {
            crewItemImg: '',
            crewItemTitle: '3 Backend-разработчика',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: '2 Frontend-разработчика',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: '4 SEO-специалиста',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'DevOps',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'QA-инженер',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Дизайнер',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Контент-менеджер',
            crewItemSubtitle: '',
        },
    ],
};

class Team extends Component {
    render() {
        return (
            <div className="teboil-team">
                <FullWrapper>
                    <CommonTitle>Команда</CommonTitle>
                    <CrewContainer container={team} />
                </FullWrapper>
            </div>
        );
    }
}

export default Team;
